import { render, staticRenderFns } from "./editPicTemp.vue?vue&type=template&id=d756ff82&scoped=true"
import script from "./editPicTemp.vue?vue&type=script&lang=js"
export * from "./editPicTemp.vue?vue&type=script&lang=js"
import style0 from "./editPicTemp.vue?vue&type=style&index=0&id=d756ff82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d756ff82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d756ff82')) {
      api.createRecord('d756ff82', component.options)
    } else {
      api.reload('d756ff82', component.options)
    }
    module.hot.accept("./editPicTemp.vue?vue&type=template&id=d756ff82&scoped=true", function () {
      api.rerender('d756ff82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/components/editPicTemp.vue"
export default component.exports